import React, { useEffect, useState } from 'react';
import axios from 'axios';
import parse from "html-react-parser";
import { useNavigate } from "react-router-dom";
import { variables } from './Variables.js';

export default function UFCHome() {

    const [isLoading, setNisLoading] = useState(false);
    const navigate = useNavigate();

    const jsonUrlUFC = variables.basename_url + 'updates/index/Athlethixnet_HomeEn_UFC.json';

    async function refda() {
        setNisLoading(true);
        Get_Data_UFC();
    }

    useEffect(() => {
        setNisLoading(true);
        refda();
    }, []);

    const [UFCArray, setUFCArray] = useState([]);

    async function Get_Data_UFC() {
        // تنظيف المصفوفة عند البدء لضمان عدم تكرار البيانات
        setNisLoading(true);

        axios.get(jsonUrlUFC)
            .then(function (response) {
                setNisLoading(false);
                console.log(response.data);

                const tempArray = [];
                // جلب الخبر الأول فقط كما في كود Boxing
                for (let i = 0; i < 1 && i < response.data.length; i++) {
                    tempArray.push({
                        news_title: response.data[i].news_title,
                        news_date: response.data[i].news_date.split(" ")[0],
                        Image: response.data[i].Image,
                        link: response.data[i].link,
                        Description: response.data[i].Description
                            .replace("https://menafn.com/", variables.domain_name + "/")
                            .replace("https://menafn.com", variables.domain_name)
                            .replace("MENAFN", variables.domain)
                            .replace("MENAFN", variables.domain),
                        Category: response.data[i].Category
                    });
                }
                setUFCArray(tempArray);
            })
            .catch(error => {
                console.error("Error fetching UFC data:", error);
                setNisLoading(false);
            });
    }

    // CSS مدمج لتقليل المسافات البيضاء وضمان المحاذاة الصحيحة
    const customStyle = `
        .opinion-post {
            height: auto;
            margin-bottom: 20px;
        }
        .opinion-post-item {
            height: fit-content; /* يمنع التمدد الزائد */
            padding-bottom: 5px;
        }
        .opinion-post-content p {
            margin-bottom: 10px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 4; /* يحد النص بـ 4 أسطر لتقليل الطول */
            -webkit-box-orient: vertical;
        }
        .BaskteImg {
            width: 100%;
            object-fit: cover;
            display: block;
        }
    `;

    return (
        <>
            <style>{customStyle}</style>
            <div className="opinion-post mt-3">
                {UFCArray.map(ufc =>
                    <div key={ufc.news_title}>
                        <div className="section-title">
                            <a href="UFC">
                                <h3 className="title">UFC</h3>
                            </a>
                        </div>
                        <div className="opinion-post-item">
                            <div className="finance-thumb">
                                <a href={ufc.link}>
                                    <img 
                                        className='BaskteImg rounded' 
                                        style={{ maxHeight: '300px' }} 
                                        src={ufc.Image} 
                                        alt="gallery" 
                                    />
                                </a>
                                <div className="finance-date"></div>
                            </div>
                            <div className="opinion-post-content">
                                <h3 className="title mt-3">
                                    <a href={ufc.link}>{ufc.news_title}</a>
                                </h3>
                                <p>{parse(ufc.Description)}</p>
                                
                                <div className="meta-post-2-style">
                                    <div className="meta-post-categores">
                                        <a href={ufc.link}>{ufc.Category}</a>
                                    </div>
                                    <div className="meta-post-date">
                                        <span>{ufc.news_date}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}